import Question from '../../../api/Question';
import * as types from './mutation-types';
import * as constants from '../../../utils/constants';

export const show = async ({commit}, {id}) => {
    const json = await new Question().show(id);

    commit(types.TASK_TRANSLATIONS, json.task_translation);
    commit(types.TASK_TRANSLATION_ID, json.task_translation_id);
    commit(types.HINT_TRANSLATIONS, json.hint_translation);
    commit(types.HINT_TRANSLATION_ID, json.hint_translation_id);

    if (json.questionable_type === constants.CHOICE_QUESION_TYPE) {
        commit(types.ANSWERS, json.answers.map((el) => {
            return {
                ...el,
                is_right: Boolean(el.is_right),
                title: el.text_translation,
            };
        }));
    } else {
        commit(types.PICTURES, json.answers);
    }
    commit(types.TYPE, json.questionable_type);
    commit(types.QUIZZES, json.quiz.map(el => el.id));
};

export const getAll = async ({commit}) => {
    const json = await new Question().getAll();

    commit(types.QUESTIONS, json);
};

// export const index = async ({commit}) => {
//     const json = await new Question().index();
//
//     commit(types.QUESTIONS, json.data);
// };

export const update = async ({commit}, {id, params}) => {
    await new Question().update(id, params)
};

export const store = async ({commit}, {params}) => {
    await new Question().store(params)
};

export const destroy = async ({commit}, {id}) => {
    await new Question().destroy(id)
};

export default {
    destroy,
    store,
    show,
    update,
    getAll,
};



// WEBPACK FOOTER //
// ./src/store/modules/question/actions.js